const convaiConfig = {
  apiKey: process.env.REACT_APP_CONVAI_API_KEY
};

export default convaiConfig;
